module.exports = __webpack_public_path__ + "templates.dialog.coupon_selected_retail_store-3461817a.html";